<template>
  <div class="readmore--html">
    <span
      v-html="text"
      class="fs-16 lh-24"
      :class="{ customCSS: !showFullText }"
      v-if="!showFullText"
      ref="excerptRef"
      data-nosnippet
    ></span>
    <span
      v-html="text"
      class="fs-16 lh-24"
      :class="{ customCSS: !showFullText }"
      v-show="showFullText"
    ></span>
    <template v-if="wordsConfig">
      <button
        v-if="countWordLength > textMax && !showFullText"
        class="hand black fs-16 lh-24"
        @click="showFullText = !showFullText"
        :h="heap"
        v-html="readMoreText"
      ></button>
    </template>
    <template v-else>
      <button
        v-if="text.length > textMax && !showFullText"
        class="hand black fs-16 lh-24"
        @click="showFullText = !showFullText"
        :h="heap"
        v-html="readMoreText"
      ></button>
    </template>
  </div>
</template>
<script>
import { computed, ref, onMounted } from 'vue'
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    textMax: {
      type: Number,
      default: 100,
    },
    heap: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const splitwords = (str) => {
      let regex = /[\s\r\n\t\v]+/g
      let text = str.replace(regex, ' ')
      let words = text.split(' ')
      return words.filter((w) => w.trim())
    };
    const wc = (str) => {
        let words = splitwords(str)
        return words.length
    };
    const gettext = (el) => {
        if (el.innerText) {
            return '' + el.innerText;
        }
        return '' + (el.textContent || '');
    };
    const limittext = (node, maxLength) => {
      if (node.nodeType == Node.TEXT_NODE) {
        if (node.textContent) {
          let words = splitwords(gettext(node))
          
          if (maxLength < words.length) {
            words = words.slice(0, maxLength)
            node.textContent = words.join(' ')
          }
        }
        
        return;
      }
      
      let length = 0
      let lastNode = null
      let removedNodes = [];
      let parent = node
      
      node = parent.firstChild
      
      while (node) {
        let count = wc(gettext(node))
        
        length += count
        
        if (maxLength < length) {
          if (lastNode) {
            removedNodes.push(node)
          } else {
            lastNode = node
            let x = length - maxLength
            limittext(node, count - x, '')
          }
        }
        
        node = node.nextSibling
      }
      
      for (let child of removedNodes) {
        parent.removeChild(child)
      }
    };
    
    const showFullText = ref(false)
    const wordsConfig = ref(true)
    const excerptRef = ref(null)
    
    onMounted(() => {
      let el = excerptRef.value
      let _countWordLength = wc(gettext(el))
      countWordLength.value = _countWordLength
      if (props.textMax < _countWordLength) {
        limittext(el, props.textMax);
      }
    })
    
    let countWordLength = ref(0)
    
    const readMoreText = computed(() => {
      return showFullText.value
        ? ''
        : "...&nbsp;<span class='hand black fs-16 lh-24 fw-400 underline'>read more</span> "
    })

    return {
      wordsConfig,
      countWordLength,
      showFullText,
      readMoreText,
      excerptRef
    }
  },
}
</script>
<style scoped lang="scss">
.showreadmore {
  font-size: 18px;
  line-height: 22px;
  @include phone {
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
